import React from "react";

const TypingIndicator: React.FC = () => {
  return (
    <div
      className="flex items-center gap-2 text-gray-500 text-sm px-2 py-1 select-none"
      aria-live="polite"
    >
      <img
        alt=""
        src="/images/bot_tab@3x.png"
        className="w-8 h-8 rounded-full mr-2 self-end object-cover"
      />
      <span>Đang suy nghĩ</span>
      <span className="flex items-center gap-1">
        <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce [animation-delay:-.3s]" />
        <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce [animation-delay:-.15s]" />
        <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" />
      </span>
    </div>
  );
};

export default TypingIndicator;
